<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  created () {
    this.getRouter()
  },
  methods: {
    getRouter: function () {
      console.log(this.$router)
    }
  }
}
</script>

<style scoped="scoped">
*{
  margin: 0;
  padding: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.routerBox{
  width: 100%;
  text-align: center;
  background-color: #2C3E50;
}
.routerList{
  display: inline-block;
  font-size: 26px;
  color: #42B983;
  font-weight: bold;
  width: 10%;
  text-decoration: none;
}
.router-active{
  background-color: #42B983;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/App.vue